import * as React from 'react';

import { TimerIconState } from '~shared/utils/timerIconState';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconTimerSvg } from './IconTimerSvg';

export type IconTimerProps = UseIconProps & {
  state: TimerIconState;
};

export function IconTimer({ state, ...props }: IconTimerProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <IconTimerSvg {...iconProps} state={state} />;
}
